import React, { useRef, useState } from 'react';
import { styled } from '@linaria/react';
import { useDeviceLayout } from '@vio/atlas/context/deviceLayout';
import { Box } from '@vio/atlas/helpers/Box';
import { Icon } from '@vio/atlas/Icon';
import { Text } from '@vio/atlas/Text';
import { OfferLayout } from '@vio/shared/src/search/OfferLayout';
import { useHotelCardActions } from 'hooks/useHotelCardActions';
import { SelectedElement } from 'utils/selectedElement';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { MoreDealsDropdown } from './MoreDealsDropdown';
const _exp = /*#__PURE__*/() => Text;
const SeeAllWrapper = /*#__PURE__*/styled(_exp())({
  name: "SeeAllWrapper",
  class: "spdz6oh",
  propsAsIs: true
});
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w6ahzfc",
  propsAsIs: false
});
// Added as part of df9r3t7e-desktop-more-deals-dropdown
const CTAWrapper = /*#__PURE__*/styled('div')({
  name: "CTAWrapper",
  class: "c1r2ogc1",
  propsAsIs: false
});
interface Props {
  onClick: () => void;
  // Added as part of df9r3t7e-desktop-more-deals-dropdown
  showDropdown?: boolean;
  hotelId?: string;
}
export const MoreDealsButtonVertical: React.FC<Props> = ({
  onClick,
  showDropdown = false,
  hotelId
}) => {
  // Added as part of 70766997-desktop-hotel-card-secondary-offers
  const {
    isDesktop
  } = useDeviceLayout();
  const containerRef = useRef();

  // Added as part of df9r3t7e-desktop-more-deals-dropdown
  const {
    trackUserHotelCardClicked,
    trackUserMoreDealsDropdownClosed
  } = useHotelCardActions();
  const [isDropdownOpen, setDropdownVisibility] = useState(false);
  const handleToggleDropdown = () => {
    setDropdownVisibility(value => !value);
  };

  // Added as part of df9r3t7e-desktop-more-deals-dropdown
  const handleClickOutSide = (e: MouseEvent) => {
    if (containerRef.current && e.target) {
      // If the click target is out side the More Deals button close the Popover (Dropdown)
      if (!(containerRef.current as HTMLElement).contains(e.target as Node)) {
        setDropdownVisibility(false);
        trackUserMoreDealsDropdownClosed({
          hotelId: hotelId,
          component: 'ExperimentalMoreDealsDropdown',
          selectedElement: SelectedElement.ShowAllDeals
        });
      }
    }
  };
  const handleClick = () => {
    if (showDropdown) {
      // Added as part of df9r3t7e-desktop-more-deals-dropdown
      handleToggleDropdown();
      trackUserHotelCardClicked({
        hotelId: hotelId,
        component: 'ExperimentalMoreDealsDropdown',
        selectedElement: SelectedElement.ShowAllDeals
      });
    } else {
      onClick();
    }
  };
  if (isDesktop) {
    // Added as part of df9r3t7e-desktop-more-deals-dropdown
    return <>
        <Wrapper onClick={handleClick} ref={containerRef}>
          <OfferLayout
        // dataId handles click on HotelOverlay and opens Deals Tab
        dataId={!showDropdown ? SelectedElement.ShowAllDeals : null} variant="SecondaryInline" // Added as part of 70766997-desktop-hotel-card-secondary-offers
        priceComponent={<SeeAllWrapper variant="labelS">
                {showDropdown ? <CTAWrapper data-id="ArrowIcon" className={isDropdownOpen && '__open'}>
                    <Icon name="ChevronRight" size="sm" />
                  </CTAWrapper> : <Box data-id="ArrowIcon" hasMirror marginLeft="s200" color="content.neutral.c600">
                    <Icon name="ChevronRight" size="sm" />
                  </Box>}
              </SeeAllWrapper>} providerLogoComponent={<Text variant="labelXS"
        // Added as part of 70766997-desktop-hotel-card-secondary-offers
        className="__moreDeals">
                <FormattedMessageWrapper id="hotelCard.moreDeals" defaultMessage="More deals" />
              </Text>} />
        </Wrapper>
        <MoreDealsDropdown hotelId={hotelId} isOpen={showDropdown && isDropdownOpen} anchorRef={containerRef} onOutsideClick={handleClickOutSide} />
      </>;
  }
  return <Wrapper onClick={onClick}>
      <OfferLayout variant="SecondaryDefault" priceComponent={<SeeAllWrapper variant="labelS">
            <FormattedMessageWrapper id="hotelCard.seeAll" defaultMessage="See all" />
            <Box data-id="ArrowIcon" hasMirror marginLeft="s200" color="content.neutral.c600">
              <Icon name="ChevronRight" size="sm" />
            </Box>
          </SeeAllWrapper>} providerLogoComponent={<Text variant="labelS"
    // Added as part of 70766997-desktop-hotel-card-secondary-offers
    className="__moreDeals">
            <FormattedMessageWrapper id="hotelCard.moreDeals" defaultMessage="More deals" />
          </Text>} />
    </Wrapper>;
};

require("./MoreDealsButtonVertical.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MoreDealsButtonVertical.tsx");